/***************************************************************************
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { A3D_TAG_NAMES, A3D_TAGS } from '../core';
import { TransformElement } from '../transform';
export var A3dNodeErrorNames;
(function (A3dNodeErrorNames) {
    A3dNodeErrorNames["PARENT_WARNING"] = "A3dNodeParentWarning";
})(A3dNodeErrorNames || (A3dNodeErrorNames = {}));
export const A3dNodeErrorMessages = {
    [A3dNodeErrorNames.PARENT_WARNING]: `Transform element should be a child of ${A3D_TAGS.VIEWER} or ${A3D_TAGS.NODE}`,
};
let A3dNode = class A3dNode extends TransformElement {
    async _initElement() {
        super._initElement();
    }
    /**
     * @internal
     */
    _validateParent() {
        if (this.parentElement?.tagName === A3D_TAG_NAMES.VIEWER ||
            this.parentElement?.tagName === A3D_TAG_NAMES.NODE) {
            return true;
        }
        this._warn(A3dNodeErrorMessages[A3dNodeErrorNames.PARENT_WARNING]);
        return false;
    }
    async disconnectedCallback() {
        this.node3d?.dispose();
        super.disconnectedCallback();
    }
    render() {
        return html `<slot></slot>`;
    }
};
A3dNode = __decorate([
    customElement('a3d-node')
], A3dNode);
export { A3dNode };
